<template>
	<FormGroupBox :title="this.$t('bookings.general')">
		<b-form-row>
			<b-form-group class="col-4" :label="this.$t('bookings.adults')">
				<b-form-input
					type="text"
					size="sm"
					:value="adults"
					readonly
					required
				/>
			</b-form-group>

			<b-form-group class="col-4" :label="this.$t('bookings.kids')">
				<b-form-input
					type="text"
					size="sm"
					:value="children"
					readonly
					required
				/>
			</b-form-group>

			<b-form-group class="col-4" :label="this.$t('bookings.infants')">
				<b-form-input
					type="text"
					size="sm"
					:value="infants"
					readonly
					required
				/>
			</b-form-group>
		</b-form-row>
	</FormGroupBox>
</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";
import {mapFields} from '../helpers/helpers'

export default {
	components: {
		FormGroupBox
	},
	computed:{
		//El viewModel principal esta en el modulo reservation de vuex store
		...mapFields({
			fields: ['adults','children','infants', 'id'],
			base: 'viewModel',
			mutation: 'SET_UPDATE_MODEL',
			module: 'reservation'
		}),
	},
};
</script>

